import {
    updateIsSuiteHeaderRendered,
    type UpdateIsSuiteHeaderRenderedActionMessage,
} from '../actions/publicActions';
import { mutator } from 'satcheljs';
import { getStore } from '../store/store';

export const updateIsSuiteHeaderRenderedMutator: (
    actionMessage: UpdateIsSuiteHeaderRenderedActionMessage
) => void =
    // eslint-disable-next-line owa-custom-rules/prefer-mutator-action -- BASELINE, DO NOT COPY!
    mutator(updateIsSuiteHeaderRendered, () => {
        getStore().isRendered = true;
    });
